import { Switch, Route, Redirect } from "react-router-dom";
import { isAuthenticate } from "../Configs/auth";

import FilePersona from "../Views/Candidate/FilePersona";
import Culture from "../Views/Candidate/Culture";
import Clima from "../Views/Candidate/Clime";
import ClimaSalida from "../Views/Candidate/ClimaSalida";
import Salida from "../Views/Candidate/Exit";
import MotivosSalida from "../Views/Candidate/ReasonsLeaving";
import CandidateIndex from "../Views/Candidate";
import B2EMotivaciones from "../Views/Candidate/Motivations";
import B2EProposito from "../Views/Candidate/Purpose";
import B2EEntrenamiento from "../Views/Candidate/Training";
import B2EHabilidades from "../Views/Candidate/Abilities";
import B2EPlanCarrera from "../Views/Candidate/PlanCarrera";
import B2ECanalDenuncia from "../Views/Candidate/CanalDenuncia";
import B2EIngresoDenuncia from "../Views/Candidate/IngresoDenuncia";
import B2EProfileEdit from "../Views/Candidate/Profile/Profile";
import ProfessionalExperience from "../Views/Candidate/ProfessionalExperience";
import InfoEducacion from "../Views/Candidate/Education";
import InfoSalario from "../Views/Candidate/Salary";
import InternalVacanciesEmployeeView from "../Views/Candidate/InternalVacanciesEmployeeView";
import ReceivedMessages from "../Views/Candidate/ReceivedMessages";
import Presentation from "../Views/Candidate/Presentation";
import Login from "../Views/Login/Login";
import SignupCandidate from "../Views/SignupCandidate/SignupCandidate";
import CandidateSignUp from "../Views/Signup/CandidateSignUp";
import Permission from "../Components/Errors/Permission";
import References from "../Views/Candidate/References";
import Jobs from "../Views/Jobs/Jobs";
import ShowMeTheMoney from "../Views/Candidate/ShowMeTheMoney";
import Genes from "../Views/Candidate/Genes";
import Processes from "../Views/Candidate/Processes";
import CandidateCV from "../Views/Candidate/CandidateCV";

import PublicCandidateOverview from "../Views/Candidate/Public/PublicOverview";
import FirstLogin from "../Views/FirstLogin/firstLogin";
import MiniProfile from "../Views/Candidate/miniProfile";

export const PrivateRoute = ({ component: Component, ...rest }) => {
	return <Route {...rest} render={(props) => (isAuthenticate() ? <Component {...props} /> : <Redirect to="/" />)} />;
};

export const LoginRoute = () => {
	return (
		<Switch>
			<Route exact path="/" component={Login} />
			<Route exact path="/error" component={Permission} />
			<Route exact path="/signup" component={CandidateSignUp} />
			<Route exact path="/signup/:email" component={SignupCandidate} />
			<Route exact path="/profile/overview/:hash" component={PublicCandidateOverview} />
			<PrivateRoute path="/candidate" component={CandidateIndex} />
		</Switch>
	);
};

export const CandidatesRoutes = ({ user }) => {
	if (user.roleId === 1) {
		return <Permission route="/app" />;
	}

	return (
		<Switch>
			<PrivateRoute exact path="/candidate" component={FilePersona} />
			<PrivateRoute exact path="/candidate/climaycultura" component={Culture} />
			<PrivateRoute exact path="/candidate/clima" component={Clima} />
			<PrivateRoute exact path="/candidate/encuesta-salida" component={ClimaSalida} />
			<PrivateRoute exact path="/candidate/culture" component={Culture} />
			<PrivateRoute exact path="/candidate/habilidades" component={B2EHabilidades} />
			<PrivateRoute exact path="/candidate/motivaciones" component={B2EMotivaciones} />
			<PrivateRoute exact path="/candidate/proposito" component={B2EProposito} />
			<PrivateRoute exact path="/candidate/entrenamiento" component={B2EEntrenamiento} />
			<PrivateRoute exact path="/candidate/motivossalida" component={MotivosSalida} />
			<PrivateRoute exact path="/candidate/salida" component={Salida} />
			<PrivateRoute exact path="/candidate/references" component={References} />
			<PrivateRoute exact path="/candidate/canaldenuncia" component={B2ECanalDenuncia} />
			<PrivateRoute exact path="/candidate/ingresodenuncia" component={B2EIngresoDenuncia} />
			<PrivateRoute exact path="/candidate/plandecarrera" component={B2EPlanCarrera} />
			<PrivateRoute exact path="/candidate/edit-profile" component={B2EProfileEdit} />
			<PrivateRoute exact path="/candidate/professionalinfo" component={ProfessionalExperience} />
			<PrivateRoute exact path="/candidate/formationinfo" component={InfoEducacion} />
			<PrivateRoute exact path="/candidate/salaryinfo" component={InfoSalario} />
			<PrivateRoute exact path="/candidate/internalvacancies" component={InternalVacanciesEmployeeView} />
			<PrivateRoute exact path="/candidate/internal-messages" component={ReceivedMessages} />
			<PrivateRoute exact path="/candidate/presentation" component={Presentation} />
			<PrivateRoute exact path="/candidate/show-me-the-money" component={ShowMeTheMoney} />
			<PrivateRoute exact path="/candidate/genes" component={Genes} />
			<PrivateRoute exact path="/candidate/processes" component={Processes} />
			<PrivateRoute exact path="/candidate/candidatecv" component={CandidateCV} />
			<PrivateRoute exact path="/candidate/opportunities" component={Jobs} />
			<PrivateRoute exact path="/candidate/first-login" component={FirstLogin} />
			<PrivateRoute exact path="/candidate/miniprofile" component={MiniProfile} />
		</Switch>
	);
};
